/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeLocationStates.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   State Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, May 13, 2019 - 04:47:35 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      05/13/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const STATE_LIST_CONTAINER_LOADED = 'STATE_LIST_CONTAINER_LOADED';
export const STATE_LIST_CONTAINER_UNLOADED = 'STATE_LIST_CONTAINER_UNLOADED';
export const STATE_LIST_TABLE_LOADED = 'STATE_LIST_TABLE_LOADED';
export const STATE_LIST_TABLE_UNLOADED = 'STATE_LIST_TABLE_UNLOADED';

export const STATE_LIST_CHANGE_GROUP = 'STATE_LIST_CHANGE_GROUP';
export const STATE_SELECT_ROW = 'STATE_SELECT_ROW';

export const STATE_ADD = 'STATE_ADD';
export const STATE_EDIT = 'STATE_EDIT';
export const STATE_DELETE = 'STATE_DELETE';
export const STATE_OPEN_WARNING = 'STATE_OPEN_WARNING';
export const STATE_CLOSE_WARNING = 'STATE_CLOSE_WARNING';
export const STATE_DELETE_DISABLE = 'STATE_DELETE_DISABLE';
export const STATE_VIEW_CHILD_ITEMS = 'STATE_VIEW_CHILD_ITEMS';

export const STATE_EDIT_CONTAINER_LOADED = 'STATE_EDIT_CONTAINER_LOADED';
export const STATE_EDIT_CONTAINER_UNLOADED = 'STATE_EDIT_CONTAINER_UNLOADED';
export const STATE_EDIT_FORM_LOADED = 'STATE_EDIT_FORM_LOADED';
export const STATE_EDIT_FORM_UNLOADED = 'STATE_EDIT_FORM_UNLOADED';

export const STATE_SET_GROUP_SELECT = 'STATE_SET_GROUP_SELECT';
export const STATE_EDIT_DATA_LOAD = 'STATE_EDIT_DATA_LOAD';

export const STATE_EDIT_CONTAINER_SUBMIT = 'STATE_EDIT_CONTAINER_SUBMIT';
export const STATE_EDIT_CONTAINER_CANCEL = 'STATE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeLocationStates.js